import { render } from "./StaffPersonalInfo.vue?vue&type=template&id=e0baf30a&scoped=true"
import script from "./StaffPersonalInfo.vue?vue&type=script&lang=js"
export * from "./StaffPersonalInfo.vue?vue&type=script&lang=js"

import "./StaffPersonalInfo.vue?vue&type=style&index=0&id=e0baf30a&scoped=true&lang=css"

import exportComponent from "/var/www/html/vitare-carenew/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0baf30a"]])

export default __exports__